// This small module runs before the full configurator graph, so opening images download in parallel with 3D code.
import {ARTWORK_NAMES} from './scl-artworks.js?v=2026091301';
import {artworkUrl} from './scl-runtime.js?v=2026091301';
import {randomIntroIndex} from './scl-intro-motion.js?v=2026091312';
import {resolveArtworkSelection} from './scl-artwork-selection.js?v=2026092101';
const selection=resolveArtworkSelection(location.search);
const requestedWallpaper=ARTWORK_NAMES.indexOf(new URLSearchParams(location.search).get('wallpaper'));
const selectedIndex=selection.index,wallpaperIndex=requestedWallpaper>=0?requestedWallpaper:ARTWORK_NAMES.indexOf('340');
let previousIntro=-1,previousWallpaper=-1;
try{previousIntro=Number(localStorage.getItem('shejtano-intro-artwork'));previousWallpaper=Number(localStorage.getItem('shejtano-intro-wallpaper'))}catch{}
const introIndex=randomIntroIndex(ARTWORK_NAMES.length,[selectedIndex,wallpaperIndex],previousIntro);
const introWallpaperIndex=randomIntroIndex(ARTWORK_NAMES.length,[selectedIndex,wallpaperIndex,introIndex],previousWallpaper);
const reduced=selection.direct||matchMedia('(prefers-reduced-motion: reduce)').matches;
function openingImage(index,width,priority){
 const image=new Image();image.crossOrigin='anonymous';image.decoding='async';image.fetchPriority=priority;
 image.src=artworkUrl(index,width);
 return image.decode().then(()=>image).catch(()=>null);
}
export const startup={selectedIndex,wallpaperIndex,introIndex,introWallpaperIndex,screenImage:null,directSelection:selection.direct};
startup.selected=openingImage(selectedIndex,1024,'high');
startup.cover=reduced?Promise.resolve(null):openingImage(introIndex,1024,'high');
startup.screen=reduced?Promise.resolve(null):openingImage(introWallpaperIndex,512,'auto').then(image=>{startup.screenImage=image;return image});

startup.finalScreen=openingImage(wallpaperIndex,512,'auto');
